import { writable, get } from 'svelte/store'
import { routerStore } from '../stores/router-store.js'
import { authStore } from '../stores/auth-store.js'
import { dateToDatabaseDate, dateToDatestring, dateStringToDate } from '../helpers/helpers.js'
import { serviceWorker } from '../helpers/service-worker.js'


export const timesStore = writable({
	days: {}
})


export function timesStoreInit() {
	timesStoreGetSWTimes(new Date())
	timesStoreSetSWListener()
	// TODO: Subscribe to updates
	// timesStoreGetTimesUpdates()
}

export function timeStoreListenToDay(day) {
	const date = dateStringToDate(day)
	timesStoreGetEntries(date)
	timesStoreGetSWTimes(date)
}

function timesStoreGetSWTimes(day) {
	if(serviceWorker && serviceWorker.active) {
		serviceWorker.active.postMessage({
			action: 'findAssets',
			store: 'time',
			index: 'day',
			val: dateToDatestring(day)
		})
	}
}


function timesStoreSetSWListener() {
	navigator.serviceWorker.addEventListener('message', e => {
		if(e.data.action === 'databaseUpdated' && e.data.store === 'time') {
			const entry = e.data.data
			timesStore.update(timesStoreData => {
				timesStoreData.days[entry.day] = timesStoreData.days[entry.day] ? timesStoreData.days[entry.day] : {}
				timesStoreData.days[entry.day][entry.id] = entry
				return timesStoreData
			})
		}
	})
}


async function timesStoreGetEntries(day) {
	const { data, error } = await supabase
		.from('times')
		.select()
		.filter('day', 'eq', dateToDatabaseDate(day))
		.order('created_at', { ascending: false })

	if(error) {
		console.log(error)
	}

	data.forEach(time => {

		if(serviceWorker && serviceWorker.active) {
			serviceWorker.active.postMessage({
				action: 'updateDatabase',
				store: 'time',
				data: time
			})
		}
	})

	return data
}


export async function timesStoreNew(day) {
	const { data, error } = await supabase
		.from('times')
		.insert([{
			created_by: (supabase.auth.user()).id,
			day: dateToDatabaseDate(day)
		}])

	if(error) {
		console.log(error)
	}

	return data
}


export async function timesStoreUpdateDuration({ id, duration }) {
	const { data, error } = await supabase
		.from('times')
		.update({ duration })
		.match({ id })

	if(error) {
		console.log(error)
	}

	return data
}


export async function timesStoreUpdateProject({ id, project }) {
	const { data, error } = await supabase
		.from('times')
		.update({ project })
		.match({ id })

	if(error) {
		console.log(error)
	}

	return data
}


export async function timesStoreUpdateComment({ id, comment }) {
	const { data, error } = await supabase
		.from('times')
		.update({
			comment,
			comment_updated: (new Date()).toISOString() 
		})
		.match({ id })

	if(error) {
		console.log(error)
	}

	return data
}



export async function timesStoreDelete({ id }) {
	const { data, error } = await supabase
		.from('times')
		.delete()
		.match({ id })

	if(error) {
		console.log(error)
	}

	return data
}


export async function timesStoreGetReportPeriod({ dayStart, dayEnd }) {

	console.log('timesStoreGetReportPeriod', dayStart, dayEnd)

	const { data, error } = await supabase
		.from('times')
		.select()
		.gte('day', dateToDatabaseDate(dayStart))
		.lte('day', dateToDatabaseDate(dayEnd))
		.order('created_at', { ascending: false })

	if(error) {
		console.log(error)
	}

	return data
}